<div class="container py-3 py-md-4">
  <!-- Back Button -->
  <button
    *ngIf="domainService.isCommunityDomain()"
    class="btn btn-outline-primary mb-3 d-flex align-items-center gap-2 btn-lite-blue"
    (click)="goBack()">
    <i class="bi bi-arrow-left"></i> Back
  </button>

  <!-- Header -->
  <header class="row align-items-start gap-3 mb-4 mb-md-5 p-3 p-md-4 bg-light rounded-3 shadow-sm">
    <!-- Profile Photo -->
    <div class="col-md-auto text-center">
      <div class="position-relative profile-photo-container" style="width: 120px; height: 120px">
        <img [src]="profilePhoto" alt="Profile Photo" class="w-100 h-100 rounded-circle object-fit-cover shadow" />
        <div class="photo-update-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-circle">
          <label for="photo-upload" class="update-photo-btn text-white fs-5 fs-md-4">
            <i class="bi bi-camera"></i>
          </label>
          <input
            type="file"
            id="photo-upload"
            class="d-none"
            (change)="onPhotoUpload($event)"
            accept="image/*" />
        </div>
      </div>
    </div>

    <!-- Profile Info -->
    <div class="col profile-info text-center text-md-start">
      <h1 class="profile-name mb-2 mb-md-3 fw-bold">{{ profileDetails?.name }}</h1>

      <h3 class="designation" *ngIf="profileDesignation?.length">
        <span>{{ profileDesignation?.[0]?.designation }}</span>
      </h3>

      <div class="d-flex flex-column gap-2">
        <div *ngIf="profileDetails?.country?.trim()" class="d-flex align-items-center justify-content-center justify-content-md-start">
          <i class="bi bi-geo-alt me-2 text-secondary"></i>
          <span>{{ profileDetails?.country }}</span>
        </div>

        <div *ngIf="profileDetails?.email?.trim()" class="d-flex align-items-center justify-content-center justify-content-md-start">
          <i class="bi bi-envelope me-2 text-secondary"></i>
          <span>{{ profileDetails?.email }}</span>
        </div>

        <div *ngIf="profileDetails?.phone?.trim()" class="d-flex align-items-center justify-content-center justify-content-md-start">
          <i class="bi bi-telephone me-2 text-secondary"></i>
          <span>{{ profileDetails?.country_code }} {{ profileDetails?.phone }}</span>
        </div>

        <div *ngIf="profileDetails?.about_me?.trim()" class="d-flex align-items-start">
          <i class="bi bi-person-lines-fill me-2 text-secondary mt-1"></i>
          <div class="flex-grow-1">
            <div #aboutMeEl [ngClass]="{ 'truncate-about': !showFullAbout }" class="text-break">
              {{ profileDetails?.about_me }}
            </div>
            <div *ngIf="isClamped" class="mt-1">
              <button type="button" class="btn btn-link p-0 small" (click)="toggleAbout()">
                {{ showFullAbout ? 'See less' : 'See more' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dropdown Actions -->
    <div class="col-12 col-md-auto d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
      <a ngbDropdown>
        <button ngbDropdownToggle>
          <img src="/icons/Profile-action.png" alt="Actions" class="profile_action__icons" />
        </button>
        <div ngbDropdownMenu>
          <button ngbDropdownItem class="add_to_project" (click)="editProfileClicked()">Edit Profile</button>
        </div>
      </a>
    </div>
  </header>

  <main>
    <!-- Desktop -->
    <div class="d-none d-md-block">
      <ul ngbNav #nav="ngbNav" class="nav-tabs mb-3" [activeId]="activeTabId">
        <li ngbNavItem="overview">
          <a ngbNavLink>Overview</a>
          <ng-template ngbNavContent>
            <div class="bg-white rounded-bottom-3 p-3 p-md-4 shadow-sm">
              <div class="mb-3 d-flex">
                <div class="me-3 fw-bold">Education:</div>
                <div>{{ profileDetails?.education_level }}</div>
              </div>
              <div class="mb-3 d-flex">
                <div class="me-3 fw-bold">Experience:</div>
                <div>{{ profileDetails?.experience_years }}</div>
              </div>
              <div class="mb-3 d-flex">
                <div class="me-3 fw-bold">Skills:</div>
                <div>
                  <span *ngFor="let skill of profileSkills; let last = last">
                    {{ skill.skill }}{{ !last ? ' | ' : '' }}
                  </span>
                </div>
              </div>
              <div class="mb-3 d-flex">
                <div class="me-3 fw-bold">Work Permit:</div>
                <div>
                  <span *ngFor="let country of profileDetails?.workAuthorizations; let last = last">
                    {{ country.country }} ({{ country.authorization }}){{ !last ? ' | ' : '' }}
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <li ngbNavItem="cv" *ngIf="!IsRecruiter">
          <a ngbNavLink>CV</a>
          <ng-template ngbNavContent>
            <div class="bg-white rounded-bottom-3 p-3 p-md-4 shadow-sm">
              <form [formGroup]="uploadResumeFileForm">
                <div class="dragSection" appDnd (fileDropped)="onFileDropped($event)">
                  <input type="file" #fileDropRef id="fileDropRef" (change)="onFileSelect($event)" accept=".pdf,.doc,.docx" />
                  <h3>Drag and drop your CV here to upload (max 5MB).</h3>
                  <h3>or</h3>
                  <label for="fileDropRef" class="cvaddbuttonLevel">Browse for file</label>
                </div>
              </form>
              <ngx-doc-viewer *ngIf="datalocalURL" [url]="datalocalURL" [viewer]="viewerType" class="with__resume" style="height: 40vh"></ngx-doc-viewer>
              <div *ngIf="!datalocalURL" style="height: 30vh">&nbsp;&nbsp;No Resume available.</div>
            </div>
          </ng-template>
        </li>

        <li ngbNavItem="availability" *ngIf="!IsRecruiter">
          <a ngbNavLink>Availability</a>
          <ng-template ngbNavContent>
            <div class="alert availability-banner d-flex align-items-center gap-2 mb-3"
                 *ngIf="showAvailabilityBanner"
                 [ngClass]="{
                   'alert-success': traffic === 'green',
                   'alert-warning': traffic === 'yellow',
                   'alert-danger': traffic === 'red',
                   'alert-secondary': traffic === 'unknown'
                 }">
              <i class="bi bi-speedometer2"></i>
              <span>{{ availabilityBannerMsg }}</span>
            </div>

            <div class="row g-4">
              <div class="col-md-6">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h5 class="card-title d-flex justify-content-between section-title">
                      Availability
                      <button class="btn btn-sm btn-outline-primary btn-lite-blue" (click)="openAvailabilityModal()">Edit</button>
                    </h5>

                    <div *ngIf="currentAvailability?.start_at || currentAvailability?.duration_id; else noAvailability">
                      <p class="mb-0 fw-semibold" [ngClass]="getAvailabilityBadgeClass(currentAvailability)">
                        {{ getAvailabilityStatus(currentAvailability) }}
                      </p>
                    </div>

                    <ng-template #noAvailability>
                      <p class="text-muted">No availability information yet.</p>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h5 class="card-title d-flex justify-content-between section-title">Share Availability</h5>
                    <ng-template #noShare>
                      <p class="text-muted">Sharing is not enabled.</p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <li ngbNavItem="settings" *ngIf="domainService.isCommunityDomain()">
          <a ngbNavLink>Settings</a>
          <ng-template ngbNavContent>
            <div class="bg-white rounded-bottom-3 p-3 p-md-4 shadow-sm">
              <h5 class="fw-bold mb-3">Profile Settings</h5>
              <div class="d-flex align-items-center gap-3 mb-3">
                <label [attr.for]="'emailToggle'" class="form-check-label text-secondary me-2">
                  {{ IsRecruiter ? 'Job Apply / Post Reply Notification' : 'Post Reply Notification' }}
                </label>
                <div class="form-check form-switch m-0">
                  <input class="form-check-input" type="checkbox" id="emailToggle" [checked]="replyPostSettings" (change)="toggleEmailNotification($event)" />
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <li ngbNavItem="posts" *ngIf="domainService.isCommunityDomain()">
          <a ngbNavLink>Posts</a>
          <ng-template ngbNavContent>
            <div class="bg-white rounded-bottom-3 p-3 p-md-4 shadow-sm">
              <div *ngIf="isLoadingUserPosts" class="text-center my-5">
                <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
              </div>

              <ng-container *ngIf="!isLoadingUserPosts && userPosts.length > 0; else noUserPosts">
                <app-post-item
                  *ngFor="let post of userPosts; trackBy: trackByPostId"
                  [post]="post"
                  [isMobile]="isMobile"
                  [activeReplyPostId]="activeReplyPostId"
                  [submittingReplyPostId]="submittingReplyPostId"
                  (toggleReply)="toggleReply($event)"
                  (submitReply)="submitReply($event)"
                  [communityID]="communityID"
                  [currentUserId]="userId"
                  (deletePost)="onDeletePost($event)"></app-post-item>
              </ng-container>

              <ng-template #noUserPosts>
                <div class="text-center text-muted mt-4">
                  <i class="bi bi-chat-left-dots fs-1"></i>
                  <p>No posts yet by this user.</p>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-0"></div>
    </div>

    <!-- Mobile -->
    <div class="d-md-none d-flex flex-column gap-3 gap-md-4">
      <section class="bg-white rounded-3 p-3 p-md-4 shadow-sm">
        <h2 class="section-title mb-2 mb-md-3 fw-semibold">Overview</h2>
        <p><strong>Education:</strong> {{ profileDetails?.education_level }}</p>
        <p><strong>Experience:</strong> {{ profileDetails?.experience_years }}</p>
        <p>
          <strong>Skills:</strong>
          <span *ngFor="let skill of profileSkills; let last = last">{{ skill.skill }}{{ !last ? ' | ' : '' }}</span>
        </p>
        <p>
          <strong>Work Permit:</strong>
          <span *ngFor="let country of profileDetails?.workAuthorizations; let last = last">
            {{ country.country }} ({{ country.authorization }}){{ !last ? ' | ' : '' }}
          </span>
        </p>
      </section>

      <section class="bg-white rounded-3 p-3 p-md-4 shadow-sm" *ngIf="!IsRecruiter">
        <h2 class="section-title mb-2 mb-md-3 fw-semibold">CV</h2>
        <form [formGroup]="uploadResumeFileForm">
          <div class="dragSection mb-3" appDnd (fileDropped)="onFileDropped($event)">
            <input type="file" #fileDropRef id="fileDropRefMobile" (change)="onFileSelect($event)" accept=".pdf,.doc,.docx" />
            <h3>Drag and drop your CV here to upload (max 5MB).</h3>
            <h3>or</h3>
            <label for="fileDropRefMobile" class="cvaddbuttonLevel">Browse for file</label>
          </div>
        </form>
        <ngx-doc-viewer *ngIf="datalocalURL" [url]="datalocalURL" [viewer]="viewerType" class="with__resume" style="height: 40vh"></ngx-doc-viewer>
        <div *ngIf="!datalocalURL" style="height: 30vh">No Resume available.</div>
      </section>

      <section class="bg-white rounded-3 p-3 p-md-4 shadow-sm" *ngIf="!IsRecruiter">
        <h2 class="section-title mb-2 mb-md-3 fw-semibold">Availability</h2>

        <div class="alert d-flex align-items-center gap-2 mb-3"
             *ngIf="showAvailabilityBanner"
             [ngClass]="{
               'alert-success': traffic === 'green',
               'alert-warning': traffic === 'yellow',
               'alert-danger': traffic === 'red',
               'alert-secondary': traffic === 'unknown'
             }">
          <i class="bi bi-speedometer2"></i>
          <span>{{ availabilityBannerMsg }}</span>
        </div>

        <div *ngIf="currentAvailability?.start_at || currentAvailability?.duration_id; else noAvailabilityMobile">
          <p class="mb-0 fw-semibold" [ngClass]="getAvailabilityBadgeClass(currentAvailability)">
            {{ getAvailabilityStatus(currentAvailability) }}
          </p>
        </div>

        <ng-template #noAvailabilityMobile>
          <p class="text-muted">No availability information yet.</p>
        </ng-template>

        <button class="btn btn-outline-primary btn-lite-blue w-100 mt-3" (click)="openAvailabilityModal()">Edit Availability</button>
      </section>

      <section class="bg-white rounded-3 p-3 p-md-4 shadow-sm mt-3" *ngIf="domainService.isCommunityDomain()">
        <h2 class="section-title mb-2 mb-md-3 fw-semibold">Settings</h2>
        <div class="d-flex align-items-center gap-3 mb-3">
          <label [attr.for]="'emailToggleMobile'" class="form-check-label text-secondary me-2">
            {{ IsRecruiter ? 'Job Apply / Post Reply Notification' : 'Post Reply Notification' }}
          </label>
          <div class="form-check form-switch m-0">
            <input class="form-check-input" type="checkbox" id="emailToggleMobile" [checked]="replyPostSettings" (change)="toggleEmailNotification($event)" />
          </div>
        </div>
      </section>

      <!-- Mobile Posts -->
      <section *ngIf="userPosts.length > 0; else noMobileUserPosts" class="bg-white rounded-3 p-3 shadow-sm">
        <h2 class="section-title mb-2 fw-semibold">Posts</h2>
        <div *ngIf="isLoadingUserPosts" class="text-center my-4">
          <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
        </div>
        <app-post-item
          *ngFor="let post of userPosts; trackBy: trackByPostId"
          [post]="post"
          [isMobile]="true"
          [activeReplyPostId]="activeReplyPostId"
          [submittingReplyPostId]="submittingReplyPostId"
          (toggleReply)="toggleReply($event)"
          (submitReply)="submitReply($event)"
          [communityID]="communityID"
          [currentUserId]="userId"
          (deletePost)="onDeletePost($event)"></app-post-item>
      </section>

      <ng-template #noMobileUserPosts>
        <section class="bg-white rounded-3 p-3 shadow-sm text-center text-muted">
          <i class="bi bi-chat-left-dots fs-1"></i>
          <p class="mt-2">No posts yet by this user.</p>
        </section>
      </ng-template>
    </div>
  </main>
</div>

<!-- Availability Modal -->
<ng-template #availabilityModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Set Availability</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="availabilityForm">
      <div class="mb-3">
        <label class="form-label">Availability Mode</label>
        <select class="form-select" formControlName="mode" (change)="onModeChange()">
          <option value="now">Available Now</option>
          <option value="date">Available from Date</option>
        </select>
      </div>

      <div class="mb-3" *ngIf="availabilityForm?.get('mode')?.value === 'now'">
        <label class="form-label">Notice Period (if any)</label>
        <select class="form-select" formControlName="duration_id">
          <option [value]="null">Select Duration</option>
          <option *ngFor="let d of availabiltyDurations" [value]="d.duration_id">{{ d.value }}</option>
        </select>
      </div>

      <div class="mb-3" *ngIf="availabilityForm?.get('mode')?.value === 'date'">
        <label class="form-label">Start Date</label>
        <input type="date" class="form-control" formControlName="start_at" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary btn-lite-blue" (click)="saveAvailability()">Save</button>
  </div>
</ng-template>

<!-- Share Availability Modal -->
<ng-template #shareAvailabilityModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Availability</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="availabilityForm">
      <div class="mb-3">
        <label class="form-label">Header</label>
        <input class="form-control" formControlName="header" />
      </div>
      <div class="mb-3">
        <label class="form-label">Message</label>
        <textarea class="form-control" formControlName="message"></textarea>
      </div>
      <div class="mb-3">
        <label class="form-label">Alias</label>
        <input class="form-control" formControlName="alias" />
      </div>
      <div class="form-check mb-2">
        <input type="checkbox" class="form-check-input" formControlName="hide_email" />
        <label class="form-check-label">Hide Email</label>
      </div>
      <div class="form-check mb-2">
        <input type="checkbox" class="form-check-input" formControlName="hide_phone" />
        <label class="form-check-label">Hide Phone</label>
      </div>
      <div class="form-check mb-2">
        <input type="checkbox" class="form-check-input" formControlName="hide_profile_photo" />
        <label class="form-check-label">Hide Profile Photo</label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary" (click)="submitAvailabilityForm(); modal.close()">Save</button>
  </div>
</ng-template>
